import React from "react";
import Container from "@material-ui/core/Container";

function Howitwork() {
  return (
    <div className="py-8">
      <Container>
        <div className="text-black text-center font-bold text-xl">
          How ouiiwe works
        </div>

        {/* New Content Starts */}
        <div className="text-black font-bold text-lg mt-8 mb-4">Shopping</div>
        <p className="text-black text">
          Discovering meaningful products on ouiiwe is effortless. Whether you
          are looking for something handmade, thoughtful, or one of a kind,
          ouiiwe makes it easy to find real products made by real people. Just
          browse the platform, explore shops, follow your favourite creators,
          and shop directly—no noise, no big brand clutter, just genuine
          discovery.
          <br />
          Shopping on ouiiwe is about more than what you buy; it’s about who you
          are supporting. Each order includes a small $1.99 service fee that
          helps keep ouiiwe fair, community-driven, and ad-free. That way, more
          of your money goes directly to the creators you are supporting. It is
          a straightforward way to make your purchases matter more.
        </p>

        <div className="text-black font-bold text-lg mt-8 mb-4">Selling</div>
        <p className="text-black text">
          Getting started on ouiiwe is simple. Whether you are a maker, seller,
          or creative small business, all it takes is a few minutes to join.
          Just sign up, register your business, and start listing your
          products—no complicated setup, no technical barriers. We’ve made it
          easy so you can focus on what you do best: creating and connecting
          with customers.
          <br />
          Selling on ouiiwe is also refreshingly affordable. There are no
          sign-up fees, no listing charges, and no monthly subscriptions. We
          only take a small 5% commission per order processed— that’s it. You
          keep more of what you earn, while we handle the platform, payments,
          and exposure. ouiiwe is designed to empower small businesses, not take
          from them.
        </p>

        <div className="flex justify-center items-center my-4">
          <iframe
            width="420"
            height="315"
            src="https://www.youtube.com/embed/ueGZI-mBWR4"
            title="How to sell video"
          ></iframe>
        </div>

        <div className="text-black font-bold text-lg mt-8 mb-4">
          For Local Service Providers
        </div>
        <p className="text-black text">
          ouiiwe is not just for products—it’s built for local services too. If
          you are a service-based business, whether you’re a cleaner, makeup
          artist, tutor, dog walker, or anything in between, ouiiwe makes it
          easy to list your services and get booked by people in your area.
          <br />
          With our built-in availability feature, you can set your time slots,
          choose your working days, and let customers book appointments directly
          through the platform. No phone calls, no back-and-forth
          messages—amazingly simple, smart scheduling that works for both you
          and your clients.
          <br />
          ouiiwe gives service providers the same visibility, simplicity, and
          community support we offer product sellers, all in one place.
        </p>
        <div className="flex justify-center items-center my-4">
          <iframe
            width="420"
            height="315"
            src="https://www.youtube.com/embed/-Eeo63EoCSU"
            title="Listing a service"
          ></iframe>
        </div>
        <div className="text-black font-bold text-lg mt-8 mb-4">
          Promote Your Existing Website
        </div>
        <p className="text-black text">
          Already have your own website or online store? ouiiwe can help bring
          more eyes to it. Our promotional feature is perfect for small business
          owners who want more visibility without managing multiple shops.
          <br />
          When you list a product on ouiiwe, you can choose to link it directly
          to your own website. That way, when shoppers click on your product,
          they are automatically taken to your site to complete the purchase.
          <br />
          It’s a simple, low-effort way to drive traffic and attract new
          customers, while still being part of the ouiiwe community. No extra
          fees, no ads, no stress. Just more chances to be discovered by
          shoppers who care about what you create.
        </p>
        <div className="flex justify-center items-center my-4">
          <iframe
            width="420"
            height="315"
            src="https://www.youtube.com/embed/U06T_ahutsA"
            title="Promote your products"
          ></iframe>
        </div>

        <div className="center-styl mt-6 mb-10 text-center">
          <a href="/signup" className="underline text-lg font-bold">
            Get started
          </a>
        </div>
        {/* New Content Ends */}

        {/* <div className="text-black font-bold text-lg mt-8 mb-4">
          How to sell.
        </div>
        <p className="text-black text-center text">
          1) First you will need a seller account which you can create by
          transforming your existing shopper account into small business
          account. While logged in, in the side bar, click small business and
          follow the steps, you can either use your ABN or request to become a
          seller.
        </p> */}

        {/* <div className="text-black font-bold text-lg mt-8 mb-4">
          Listing a local service.
        </div> */}

        {/* <div className="text-black font-bold text-lg mt-8 mb-4">
          Promote your products
        </div> */}

        <p className="text-black text mt-10">
          <strong>Our fees:</strong>
          <br />
          Our platform connects sellers with customers, facilitates sales, and
          charges a 5% commission fee while paying out 95% of the sale price to
          the seller. The seller will be paid out within 24 hours of completing
          the order and us confirming.
        </p>
      </Container>
    </div>
  );
}

export default Howitwork;
